import { gql } from "@apollo/client";

export const USER_SIGNUP = gql`
mutation UserSignUp($registerInput:RegisterInput!) 
{
    userSignUp(registerInput:$registerInput) 
    {
        a,
        r,
        sid,
        status
    }
}
`

export const CHECK_USERNAME = gql`
    mutation CheckUsername($username: String!,$companyId: String!){
        checkUsername(username: $username,companyId: $companyId){
            status,
            isExist
        }
    }
`;
